import { useEffect, useRef, useState } from "react";
import { useDidMountEffect } from "../../utils/utils";

export default function useSgReadyHistory(
  locationClient,
  heatpumpId = null,
  isFocused = true,
) {
  const [sgReadyHistory, setSgReadyHistory] = useState(null);
  const [batch, setBatch] = useState(0);
  const [nPages, setNPages] = useState(null);

  const batchSize = 20;

  useEffect(() => {
    if (isFocused) initData();
    else clearData();
  }, [isFocused]);

  useDidMountEffect(() => {
    loadData();
  }, [batch]);

  const lastBatch = useRef(null);

  const historyRequest = async (_batch) => {
    const params = {
      order_by: "-id",
      batch: _batch,
      batch_size: batchSize,
      heatpump: heatpumpId,
    };
    const response = await locationClient.getSgReadyHistory(params);
    return response;
  };

  const addHistory = async () => {
    if (lastBatch.current === null) return 
    if (nPages !== null && lastBatch.current + 1 >= nPages) return true;
    try {
      lastBatch.current = lastBatch.current + 1;
      const response = await historyRequest(lastBatch.current || 0);
      setSgReadyHistory((r) => [...r, ...response.data]);
      return true;
    } catch (error) {
      console.warn('Error in "addHistory"', error, error.stack);
      return false;
    }
  };

  const getHistory = async () => {
    try {
      lastBatch.current = batch;
      const response = await historyRequest(batch);
      setSgReadyHistory(response.data);
      setNPages(Number(response.headers.length));
      return true;
    } catch (error) {
      console.warn('Error in "getHistory"', error, error.stack);
      return false;
    }
  };

  const loadData = getHistory;
  const clearData = () => setSgReadyHistory(null);
  const initData = async () => {
    if (batch === 0) loadData();
    else setBatch(0);
  };
  const extendData = addHistory;

  return {
    sgReadyHistory,
    data: {
      init: initData,
      update: loadData,
      clear: clearData,
      extend: extendData,
    },
    pagination: { page: batch, setPage: setBatch, nPages },
  };
}
